import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export const SPECIALTIES = gql`
        query specialties($specialtyIds: [String]) {
            specialties(specialtyIds: $specialtyIds) {
                id
                name
            }
        }
    `;

export const withSpecialty = ({ ownProp = 'specialtyId', mapResultToPropName = 'specialty' } = {}) =>
    graphql(SPECIALTIES, {
        skip: ownProps => !ownProps[ownProp],
        options: ownProps => ({
            ssr: false,
            variables: { specialtyIds: [ownProps[ownProp]] },
        }),
        props: ({ data: { specialties } }) => {
            if (specialties) {
                return { [mapResultToPropName]: specialties[0] };
            }
        },
    });
